import { render } from "./BaseMultiValueTextInput.vue?vue&type=template&id=16747c29"
import script from "./BaseMultiValueTextInput.vue?vue&type=script&lang=js"
export * from "./BaseMultiValueTextInput.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__